import { render, staticRenderFns } from "./create-course-outline.vue?vue&type=template&id=07cc6f73&scoped=true&"
import script from "./create-course-outline.vue?vue&type=script&lang=js&"
export * from "./create-course-outline.vue?vue&type=script&lang=js&"
import style0 from "./create-course-outline.vue?vue&type=style&index=0&id=07cc6f73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc6f73",
  null
  
)

export default component.exports